/**
 * Concats classNames.
 * @param {...ClassName} classes
 * @returns {string} concatted classNames
 *
 * Faster version of
 * @example
 * function classNames1(...classes) {
 *   return classes.filter(Boolean).join(" ");
 * }
 *
 * @example
 * render(
 *.  <Button
 *.    className={classNames(
 *.      isActive && "active",
 *.      isLoading && "loading",
 *.      "gallery-button",
 *.      className
 *.    )}
 *.  />
 *.)
 *
 */
export const classNames = (...classes: string[]) => {
    let res = '';
    const len = classes.length;
    for (let i = 0; i < len; i++) {
        if (classes[i]) {
            res += (res ? ' ' : '') + classes[i];
        }
    }
    return res;
};
